import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const ParcelsCouriersIcon: IconComponent = ({ className, colorCode = 'p500', width = 50, height = 50 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 192 192"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <style>{`.cls-5,.cls-6{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:7.00px;}.cls-5{stroke:${color};}.cls-6{stroke:#FF4D00;}`}</style>
            </defs>
            <polyline className="cls-5" points="96 101.49 96 157.68 47.96 133.68 47.96 75.31"></polyline>
            <polyline className="cls-5" points="96 157.68 144.04 133.68 144.04 75.64"></polyline>
            <line className="cls-5" x1="119.22" y1="62.13" x2="73.44" y2="87.89"></line>
            <polygon className="cls-5" points="96 100.82 47.99 75.31 96 49.79 144 75.31 96 100.82"></polygon>
            <line className="cls-6" x1="78.83" y1="108.9" x2="64.78" y2="101.43"></line>
            <polygon className="cls-5" points="96 100.82 47.99 75.31 96 49.79 144 75.31 96 100.82"></polygon>
        </svg>
    )
}
